import React, {Component} from 'react';
import {connect} from 'react-redux';
import ClientsActions from '../../redux/ClientsRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import PageWithTable from '../../components/PageWithTable';
import Forbidden from '../../components/Forbidden';
import {withTranslation} from 'react-i18next';

const columns = t => ([
  {
    key: 'fullName',
    dataKey: 'fullName',
    title: t('Client'),
    sortable: true,
    minWidth: 320,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'phone',
    dataKey: 'phone',
    title: t('Phone'),
    sortable: true,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'car.vin',
    dataKey: 'car.vin',
    title: t('VIN'),
    sortable: false,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'car.plate',
    dataKey: 'car.plate',
    title: t('Reg plate'),
    sortable: false,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'car.system.type',
    dataKey: 'car.system.type',
    title: t('Equipment'),
    sortable: false,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'car.dealer.name',
    dataKey: 'car.dealer.name',
    title: t('Dealer'),
    sortable: false,
    width: 0,
    flexGrow: 1,
  },
]);

const rowRenderer = ({ rowData, cells}) => {
  if (rowData.rowSpan && rowData.rowSpan > 1) {
    for (let index = 0; index < 2; index++) {
      const cell = cells[index]
      const style = {
        ...cell.props.style,
        backgroundColor: 'white',
        height: rowData.rowSpan * 50 - 1,
        alignSelf: 'flex-start',
        zIndex: 1,
      }
      cells[index] = React.cloneElement(cell, { style })
    }
  }
  return cells;
}

class ClientsPage extends Component {
  render() {
    const {
      clients,
      fetching,
      totalPages,
      getClients,
      dictionaries,
      getDictionaries,
      permissions,
      t,
    } = this.props;

    if (!permissions.clients) {
      return <Forbidden />;
    }

    return (
      <PageWithTable
        actionButton={{
          title: t('New client'),
          href: '/clients/new',
        }}
        filters={[
          {
            keyName: 'systemTypeIds',
            placeholder: t('By system type'),
            data: dictionaries.systemTypes.data,
            fetching: dictionaries.systemTypes.fetching,
            getData: getDictionaries('systemTypes'),
          },
          {
            keyName: 'regionIds',
            placeholder: t('By region'),
            data: dictionaries.regions.data,
            fetching: dictionaries.regions.fetching,
            getData: getDictionaries('regions'),
          }
        ]}
        dataColumns={columns(t)}
        data={clients}
        dataFetching={fetching}
        dataTotalPages={totalPages}
        getData={getClients}
        {...this.props}
        permissions={permissions.client}
        rowRenderer={rowRenderer}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions,
    clients: state.clients.data,
    totalPages: state.clients.totalPages,
    fetching: state.clients.fetching,
    dictionaries: state.dictionaries,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getClients: params => dispatch(ClientsActions.clientsRequest(params)),
    getDictionaries: name => () => dispatch(DictionariesActions.dictionariesRequest(name)),
  };
};

export default withTranslation('clients', 'common')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClientsPage));
